import type { Language } from "./types";

export function formatBytes(bytes: number) {
    if (!bytes) return "0 B";

    const k = 1024;
    const sizes = ["B", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const v = bytes / Math.pow(k, i);

    return `${v.toFixed(i === 0 ? 0 : 1)} ${sizes[i]}`;
}

export function formatDate(date: string, lang: Language) {
    if (!date) return "";

    const locale = lang === "da" ? "da-DK" : "en-GB";
    const d = new Date(date);

    if (Number.isNaN(d.getTime())) {
        return date;
    }

    return new Intl.DateTimeFormat(locale, {
        weekday: "short",
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    }).format(d);
}

export function getDriverStatusColor(statusId?: number) {
    switch (statusId) {
        case 1:
            return "blue";
        case 2:
            return "yellow";
        case 3:
            return "orange";
        case 4:
            return "green";
        default:
            return "gray";
    }
}